import { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import style from './inputs.module.css';
import AppGetIcon from '../../AppGetIcon';
// import AppGetIcon from '../../atoms/getIcon';
import { es } from 'date-fns/locale';

interface DateInputInterface {
  name: string;
  placeholder?: string;
  textLabel?: string;
  disabled?: boolean;
  onChange?: (date: Date | [Date, Date] | null) => void;
  showTimeSelect?: boolean;
  range?: boolean;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  classNameInput?: string;
  initialValue?: [Date, Date]; // Si siempre es rango
}


const DateInput = ({
  name,
  placeholder,
  textLabel,
  disabled,
  onChange,
  showTimeSelect = false,
  range = false,
  dateFormat = "dd-MM-yyyy",
  minDate,
  maxDate,
  classNameInput,
  initialValue // Recibe el valor inicial

}: DateInputInterface) => {
  const [selectedDate, setSelectedDate] = useState<any | [Date, Date] | null>(initialValue || '');
  const handleChange = (date: Date | [Date, Date] | null) => {
    setSelectedDate(date);
  
    if (onChange) {
      if (range) {
        // Si es rango, 'date' debería ser [Date, Date] | null
        if (Array.isArray(date)) {
          onChange(date); // date es [Date, Date] | null, compatible con el tipo de onChange en rango
        } else {
          // Aquí podrías manejar el caso cuando no venga como arreglo, 
          // pero idealmente si 'range' es true, 'date' siempre debería ser un arreglo.
          onChange(null);
        }
      } else {
        // Si no es rango, 'date' debería ser Date | null
        if (date instanceof Date || date === null) {
          onChange(date); // Aquí date es Date | null
        } else {
          // Si por algún motivo viene un arreglo sin ser rango, lo ignoras:
          onChange(null);
        }
      }
    }
  };
  


  return (
    <div className={style.container__input}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>

      {textLabel && <label htmlFor={name} className={style.input__label}>{textLabel}</label>}
    </div>

      <DatePicker
        selected={(range && Array.isArray(selectedDate) ? selectedDate[0] ?? '' : selectedDate ?? '') as Date}
        onChange={handleChange}
        startDate={range && Array.isArray(selectedDate) ? selectedDate[0] ?? '' : ''}
        endDate={range && Array.isArray(selectedDate) ? selectedDate[1] ?? '' : ''}
        selectsRange={range}
        showTimeSelect={showTimeSelect}
        timeFormat="HH:mm"
        dateFormat={dateFormat}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        placeholderText={placeholder}
        className={classNameInput ? `${classNameInput} ${range ? style.date__range : style.datepicker}` : `${style.input__input} ${range ? style.date__range : style.datepicker}`}
        showIcon
        icon={<AppGetIcon name='calendar' />}  // Esto debería funcionar ahora correctamente
        isClearable
        locale={es}
        showYearDropdown
        showMonthDropdown
      />
    </div>
  );
};

export default DateInput;
